import * as Styled from './styled'

interface IDropdownOption {
  id: number
  value: string
  label: string
}

interface IDropdownProps {
  value: string
  onChange: (value: string) => void
  options: IDropdownOption[]
  placeholder?: string
  disabled?: boolean
}

export const Dropdown = ({
  value,
  onChange,
  options,
  placeholder,
  disabled
}: IDropdownProps) => {
  return (
    <Styled.StyledSelect
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map(option => (
        <option key={option.id} value={option.value}>
          {option.label}
        </option>
      ))}
    </Styled.StyledSelect>
  )
}
